import {algoliasearch} from "algoliasearch";
import {ID, KEY, KEYWRITE} from "../Constantes";

export const guardarRegistro = ({obj, coleccion, id}) => {


    obj.objectID = id

    const client = algoliasearch(ID, KEYWRITE);

    return client.saveObject({
        indexName: coleccion,
        body: obj
    })





}